import React from 'react';
import NavBar from '../components/NavBar'
import ProgramsContent from '../components/ProgramsContent';
import Contact from '../components/Contact';

const Programs = () => {
  return (
    <div>
        <NavBar />
        <ProgramsContent />
        <Contact />
    </div>
  )
}

export default Programs;